import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from './formSummary.actions';
import FormSummary from './formSummary';
import { injectIntl } from 'react-intl';


function mapStateToProps(state) {
  return {
    isLoading: state.formSummary.isLoading,
    summaryData: state.formSummary.summaryData,
    companyId: state.formSummary.companyId,
    employeeId: state.formSummary.employeeId,
    formInstanceGuid: state.formSummary.formInstanceGuid,
    includeParticipants: state.formSummary.includeParticipants,
    viewConfidentially: state.formSummary.viewConfidentially
  };
}

function mapActionsToProps(dispatch) {
  return bindActionCreators({
    ...actions,    
  }, dispatch);
}

export default injectIntl(connect(mapStateToProps, mapActionsToProps)(FormSummary));